import { render, staticRenderFns } from "./ResetForm.vue?vue&type=template&id=6eb499b7&scoped=true&"
import script from "./ResetForm.vue?vue&type=script&lang=js&"
export * from "./ResetForm.vue?vue&type=script&lang=js&"
import style0 from "./ResetForm.vue?vue&type=style&index=0&id=6eb499b7&prod&lang=scss&scoped=true&"
import style1 from "./ResetForm.vue?vue&type=style&index=1&id=6eb499b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb499b7",
  null
  
)

export default component.exports